import React from "react";
import { fmt } from "./financeUtils";

/**
 * Sabit Gider Detayı (artifact `.fx-*`).
 * rows: [{key,label,monthly,yearly}] — outcome categories,
 * monthly = selected month total, yearly = selected year total.
 */
const FixedExpenses = ({ rows, yearShort }) => {
  const totM = rows.reduce((s, r) => s + r.monthly, 0);
  const totY = rows.reduce((s, r) => s + r.yearly, 0);

  return (
    <section>
      <div className="flex justify-between items-baseline mx-1 mb-2">
        <h2 className="fin-grot text-[14px] font-semibold text-[var(--fin-text)]">
          Sabit Gider Detayı
        </h2>
        <span className="text-[11px] text-[var(--fin-muted)]">aylık ↔ yıllık</span>
      </div>
      <div className="fin-card">
        <div className="grid grid-cols-[1fr_84px_90px] sm:grid-cols-[1fr_90px_96px] px-4 pt-2.5 pb-[7px] text-[10px] font-bold uppercase tracking-[0.07em] text-[var(--fin-muted)] border-b border-[var(--fin-line)]">
          <span>Kalem</span>
          <span className="text-right">Aylık</span>
          <span className="text-right">Yıllık ’{yearShort}</span>
        </div>
        {rows.length ? (
          rows.map((r) => (
            <div
              key={r.key}
              className="grid grid-cols-[1fr_84px_90px] sm:grid-cols-[1fr_90px_96px] px-4 py-[9px] text-[12.5px] border-b border-[var(--fin-row-line)] last:border-b-0 items-center"
            >
              <span className="truncate text-[var(--fin-text)]">{r.label}</span>
              <span className="fin-grot fin-num text-right font-semibold text-[12.5px] text-[var(--fin-text)]">
                {r.monthly ? fmt(r.monthly) : "—"}
              </span>
              <span className="fin-grot fin-num text-right font-semibold text-[12.5px] text-[var(--fin-muted)]">
                {r.yearly ? fmt(r.yearly) : "—"}
              </span>
            </div>
          ))
        ) : (
          <div className="px-4 py-[26px] text-center text-[12.5px] text-[var(--fin-muted)]">
            Bu dönemde gider kaydı yok.
          </div>
        )}
        <div className="grid grid-cols-[1fr_84px_90px] sm:grid-cols-[1fr_90px_96px] px-4 py-[11px] font-bold text-[12.5px] bg-[var(--fin-hover)] border-t border-[var(--fin-line)] text-[var(--fin-text)]">
          <span>Toplam gider</span>
          <span className="fin-grot fin-num text-right">{totM ? fmt(totM) : "—"}</span>
          <span className="fin-grot fin-num text-right">{totY ? fmt(totY) : "—"}</span>
        </div>
      </div>
    </section>
  );
};

export default FixedExpenses;
